import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconStarShooting: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0608 15.625C14.8625 15.625 14.6617 15.5775 14.4775 15.48L12.19 14.2833L9.93663 15.4792C9.51079 15.7025 9.00255 15.665 8.61338 15.3817C8.22422 15.0983 8.0342 14.6284 8.11503 14.155L8.55082 11.6258L6.65497 9.80916C6.32164 9.48416 6.20247 9.00833 6.34664 8.56583C6.48997 8.12333 6.86581 7.80582 7.32747 7.73916L9.96419 7.35748L11.08 5.07334C11.2934 4.64251 11.7241 4.375 12.2066 4.375C12.6875 4.375 13.1192 4.64251 13.3325 5.07334L14.475 7.37752L17.085 7.73916C17.5466 7.80582 17.9225 8.12249 18.0658 8.56583C18.21 9.00833 18.0908 9.485 17.7575 9.80916L15.8508 11.6592L16.2983 14.1575C16.38 14.6317 16.1883 15.1009 15.7992 15.3834C15.5783 15.5434 15.3208 15.625 15.0608 15.625ZM12.205 13.0375C12.3983 13.0375 12.5925 13.0833 12.7692 13.1767L15.0567 14.3733L14.6283 11.8383C14.56 11.445 14.69 11.0416 14.9783 10.7625L16.885 8.91251L14.2675 8.59502C13.8716 8.53835 13.5291 8.29 13.3525 7.93167L12.2108 5.62917C12.2091 5.62584 12.2075 5.62419 12.2075 5.62419L11.0558 7.93335C10.88 8.29002 10.5375 8.53834 10.1417 8.59584L7.50498 8.97751L9.43166 10.7633C9.71833 11.0417 9.85001 11.4433 9.78251 11.8383L9.34662 14.3692L11.6416 13.1775C11.8191 13.0833 12.0125 13.0375 12.205 13.0375ZM6.45833 14.1667C6.45833 13.8217 6.17833 13.5417 5.83333 13.5417H2.5C2.155 13.5417 1.875 13.8217 1.875 14.1667C1.875 14.5117 2.155 14.7917 2.5 14.7917H5.83333C6.17833 14.7917 6.45833 14.5117 6.45833 14.1667ZM4.79167 10C4.79167 9.655 4.51167 9.375 4.16667 9.375H2.5C2.155 9.375 1.875 9.655 1.875 10C1.875 10.345 2.155 10.625 2.5 10.625H4.16667C4.51167 10.625 4.79167 10.345 4.79167 10ZM6.45833 5.83333C6.45833 5.48833 6.17833 5.20833 5.83333 5.20833H2.5C2.155 5.20833 1.875 5.48833 1.875 5.83333C1.875 6.17833 2.155 6.45833 2.5 6.45833H5.83333C6.17833 6.45833 6.45833 6.17833 6.45833 5.83333Z"
      fill={color}
    />
  </svg>
);

export default IconStarShooting;
